module.exports = __webpack_public_path__ + "media/images/top/rank-gold-32c1a16b0207c9ba6478b58d7930d7dd.webp";